import { EdrSensorGeneralSearchableKeywords } from './edr-sensor.types';
import { SearchableKeyword } from '../../../../../../ui/gzSearchableAccordionsPanel/types';
import { translateFn } from '../../../../../../utils/translator.helper';
import { EdrSensorGeneralSection } from '@nirvana/shared/dtos/types/policies/common';

export const EDR_SENSOR_GENERAL_DEFAULT_VALUE: EdrSensorGeneralSection = {
  enabled: false,
};

// searchable keywords
export function getEdrSensorGeneralSearchableKeywords(): {
  [type in EdrSensorGeneralSearchableKeywords]: SearchableKeyword;
} {
  return {
    [EdrSensorGeneralSearchableKeywords.EdrIncidents]: {
      translatedLabel: translateFn('Incidents Sensor'),
      label: 'Incidents Sensor',
    },
  };
}
